import { useState, useEffect } from 'react';
import { Card, Btn, Pagination, usePagination } from '../../components/UI';
import { useToast } from '../../components/Toast';
import { kekuatanAPI, personelAPI } from '../../utils/api';

const th = { padding:'10px 14px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748B',borderBottom:'2px solid #E2E8F0' };
const td = { padding:'10px 14px',fontSize:13,borderBottom:'1px solid #F1F5F9',textAlign:'right' };
const tdL = { ...td, textAlign:'left' };

// Bar chart horizontal sederhana (domain-specific, tetap page-local)
const BarChart = ({ data, valueKey, labelKey, color='#2563EB' }) => {
  const max = Math.max(...data.map(d => d[valueKey] || 0), 1);
  return (
    <div style={{ display:'flex',flexDirection:'column',gap:8 }}>
      {data.map((d,i) => (
        <div key={i} style={{ display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:150,fontSize:12,color:'#374151',flexShrink:0,textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap' }}>{d[labelKey]}</div>
          <div style={{ flex:1,height:20,background:'#F1F5F9',borderRadius:4,overflow:'hidden' }}>
            <div style={{ width:`${(d[valueKey]/max)*100}%`,height:'100%',background:color,borderRadius:4,transition:'width 0.5s' }}/>
          </div>
          <div style={{ width:50,fontSize:12,fontWeight:700,color:'#374151',textAlign:'right' }}>{d[valueKey]}</div>
        </div>
      ))}
    </div>
  );
};

// ── DIAGRAM KEKUATAN ──────────────────────────────────────
const DiagramTab = () => {
  const [data, setData] = useState([]);
  const [kotamaData, setKotamaData] = useState([]);
  const [kotamaList, setKotamaList] = useState([]);
  const [selectedKotama, setSelectedKotama] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingKotama, setLoadingKotama] = useState(false);
  const [filter, setFilter] = useState({ pangkat:'' });

  useEffect(() => {
    personelAPI.getKotama().then(r => setKotamaList(r.data || [])).catch(() => {});
    load();
  }, []);

  const load = async () => {
    setLoading(true);
    const qs = filter.pangkat ? `?pangkat=${filter.pangkat}` : '';
    try { const r = await kekuatanAPI.getDiagram(qs); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  const loadKotama = async () => {
    if (!selectedKotama) return;
    setLoadingKotama(true);
    try { const r = await kekuatanAPI.getDiagramKotama(selectedKotama); setKotamaData(r.data || []); }
    catch {} finally { setLoadingKotama(false); }
  };

  useEffect(() => { if (selectedKotama) loadKotama(); }, [selectedKotama]);

  const total = data.reduce((s,d) => s + (d.jumlah||0), 0);
  const riil  = data.reduce((s,d) => s + (d.riil||0), 0);

  return (
    <>
      <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:20 }}>
        <div style={{ background:'#EFF6FF',borderRadius:12,padding:20 }}>
          <div style={{ fontSize:36,fontWeight:800,color:'#2563EB' }}>{loading ? '...' : total.toLocaleString()}</div>
          <div style={{ fontSize:13,color:'#6B7280' }}>DSP (Daftar Susunan Personel)</div>
        </div>
        <div style={{ background:'#ECFDF5',borderRadius:12,padding:20 }}>
          <div style={{ fontSize:36,fontWeight:800,color:'#059669' }}>{loading ? '...' : riil.toLocaleString()}</div>
          <div style={{ fontSize:13,color:'#6B7280' }}>Riil (Personel Aktif)</div>
        </div>
      </div>

      <Card>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16 }}>
          <h3 style={{ margin:0,fontSize:15,fontWeight:700 }}>Diagram Kekuatan Personil per Pangkat</h3>
          <div style={{ display:'flex',gap:8 }}>
            <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
              <select value={filter.pangkat} onChange={e => setFilter(f=>({...f,pangkat:e.target.value}))} style={{ width:160,padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,background:'white' }}>
                <option value="">Semua Pangkat</option>
                <option value="JENDERAL">Jenderal</option>
                <option value="LETJEN">Letjen</option>
                <option value="MAYJEN">Mayjen</option>
                <option value="BRIGJEN">Brigjen</option>
                <option value="KOLONEL">Kolonel</option>
                <option value="LETKO">Letko</option>
                <option value="MAYOR">Mayor</option>
                <option value="KAPTEN">Kapten</option>
                <option value="LETTU">Lettu</option>
                <option value="LETDA">Letda</option>
              </select>
            </div>
            <Btn onClick={load}>Filter</Btn>
          </div>
        </div>
        {loading ? <p>Loading...</p> : data.length === 0
          ? <p style={{ color:'#9CA3AF',textAlign:'center' }}>Belum ada data diagram</p>
          : <BarChart data={data} labelKey="pangkat" valueKey="riil" color="#2563EB"/>
        }
      </Card>

      <Card>
        <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>Diagram Kekuatan Personil per Kotama</h3>
        <div style={{ display:'flex',gap:12,alignItems:'flex-end',marginBottom:16 }}>
          <div style={{ display:'flex',flexDirection:'column',gap:4,flex:1 }}>
            <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Pilih Kotama</label>
            <select value={selectedKotama} onChange={e => setSelectedKotama(e.target.value)} style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,background:'white' }}>
              <option value="">— Pilih Kotama —</option>
              {kotamaList.map(k => <option key={k.id} value={k.id}>{k.nama}</option>)}
            </select>
          </div>
        </div>
        {loadingKotama ? <p>Loading...</p>
          : !selectedKotama ? <p style={{ color:'#9CA3AF' }}>Pilih Kotama untuk melihat diagram</p>
          : kotamaData.length === 0 ? <p style={{ color:'#9CA3AF',textAlign:'center' }}>Tidak ada data</p>
          : <BarChart data={kotamaData} labelKey="pangkat" valueKey="jumlah" color="#059669"/>
        }
      </Card>
    </>
  );
};

// ── PREDIKSI KEKUATAN ─────────────────────────────────────
const PrediksiTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tahun, setTahun] = useState(new Date().getFullYear() + 1);
  const pgPrediksi = usePagination(10);
  useEffect(() => { pgPrediksi.reset(); }, [data]);

  const load = async () => {
    setLoading(true);
    try { const r = await kekuatanAPI.getPrediksi(`?tahun=${tahun}`); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <>
      <Card>
        <div style={{ display:'flex',gap:12,alignItems:'flex-end',marginBottom:0 }}>
          <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
            <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Prediksi Tahun</label>
            <input type="number" value={tahun} onChange={e => setTahun(e.target.value)}
              style={{ width:200,padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
          </div>
          <Btn onClick={load}>Hitung Prediksi</Btn>
        </div>
      </Card>
      <Card>
        <h3 style={{ margin:'0 0 12px',fontSize:15,fontWeight:700 }}>Prediksi Kekuatan Personil Tahun {tahun}</h3>
        {loading ? <p>Loading...</p> : (
          (() => { const { data: paged, total, totalPages, from, to } = pgPrediksi.paginate(data); return (<>
          <table style={{ width:'100%',borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#F8FAFC' }}>
              {['Pangkat','Saat Ini','Pensiun BUP','Pensiun Aktual','Kenaikan Pangkat','Prediksi','Selisih DSP'].map(h => <th key={h} style={th}>{h}</th>)}
            </tr></thead>
            <tbody>
              {paged.length === 0
                ? <tr><td colSpan={7} style={{ ...tdL,textAlign:'center',color:'#9CA3AF' }}>Tidak ada data prediksi</td></tr>
                : paged.map((r,i) => (
                  <tr key={i} style={{ background:i%2===0?'transparent':'#FAFAFA' }}>
                    <td style={tdL}>{r.pangkat}</td>
                    <td style={td}>{r.saat_ini}</td>
                    <td style={{ ...td,color:'#EF4444' }}>{r.pensiun_bup}</td>
                    <td style={{ ...td,color:'#F59E0B' }}>{r.pensiun_aktual || 0}</td>
                    <td style={{ ...td,color:'#059669' }}>{r.naik_pangkat}</td>
                    <td style={{ ...td,fontWeight:700 }}>{r.prediksi}</td>
                    <td style={{ ...td,color:r.selisih>0?'#059669':'#EF4444',fontWeight:700 }}>{r.selisih > 0 ? `+${r.selisih}` : r.selisih}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          <Pagination page={pgPrediksi.page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pgPrediksi.pageSize} onPageChange={pgPrediksi.setPage} onPageSizeChange={pgPrediksi.setPageSize} />
          </>); })()
        )}
      </Card>
    </>
  );
};

// ── NOMINATIF KEKUATAN ────────────────────────────────────
const NominatifTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ pangkat:'', kotama_id:'' });
  const [kotamaList, setKotamaList] = useState([]);
  const [pg, setPg] = useState({ page:1, limit:20, total:0 });

  useEffect(() => {
    personelAPI.getKotama().then(r => setKotamaList(r.data || [])).catch(() => {});
    load();
  }, []);

  const load = async (page = 1) => {
    setLoading(true);
    const parts = [`page=${page}`, `limit=${pg.limit}`];
    if (filter.pangkat)   parts.push(`pangkat=${filter.pangkat}`);
    if (filter.kotama_id) parts.push(`kotama_id=${filter.kotama_id}`);
    try {
      const r = await kekuatanAPI.getNominatif(`?${parts.join('&')}`);
      setData(r.data || []);
      setPg(p => ({ ...p, page, total: r.pagination?.total || 0 }));
    } catch {} finally { setLoading(false); }
  };

  const totalPages = Math.max(1, Math.ceil(pg.total / pg.limit));

  return (
    <>
      <Card>
        <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>Filter Nominatif</h3>
        <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr auto',gap:16,alignItems:'flex-end' }}>
          <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
            <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Pangkat</label>
            <select value={filter.pangkat} onChange={e => setFilter(f=>({...f,pangkat:e.target.value}))} style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,background:'white' }}>
              <option value="">Semua Pangkat</option>
              {['JENDERAL','LETJEN','MAYJEN','BRIGJEN','KOLONEL','LETKO','MAYOR','KAPTEN','LETTU','LETDA'].map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
            <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Kotama</label>
            <select value={filter.kotama_id} onChange={e => setFilter(f=>({...f,kotama_id:e.target.value}))} style={{ padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,background:'white' }}>
              <option value="">Semua Kotama</option>
              {kotamaList.map(k => <option key={k.id} value={k.id}>{k.nama}</option>)}
            </select>
          </div>
          <Btn onClick={() => load(1)}>Filter</Btn>
        </div>
      </Card>
      <Card>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12 }}>
          <h3 style={{ margin:0,fontSize:15,fontWeight:700 }}>Nominatif Kekuatan Personil ({pg.total})</h3>
        </div>
        {loading ? <p>Loading...</p> : (
          <>
            <table style={{ width:'100%',borderCollapse:'collapse' }}>
              <thead><tr style={{ background:'#F8FAFC' }}>
                {['No','NRP','Nama','Pangkat','Corps','Jabatan','Kotama','Satminkal'].map(h => <th key={h} style={th}>{h}</th>)}
              </tr></thead>
              <tbody>
                {data.length === 0
                  ? <tr><td colSpan={8} style={{ ...tdL,textAlign:'center',color:'#9CA3AF' }}>Tidak ada data</td></tr>
                  : data.map((r,i) => (
                    <tr key={i} style={{ background:i%2===0?'transparent':'#FAFAFA' }}>
                      <td style={tdL}>{(pg.page-1)*pg.limit+i+1}</td>
                      <td style={tdL}>{r.nrp}</td>
                      <td style={tdL}>{r.nama}</td>
                      <td style={tdL}>{r.pangkat}</td>
                      <td style={tdL}>{r.corps}</td>
                      <td style={tdL}>{r.jabatan}</td>
                      <td style={tdL}>{r.kotama}</td>
                      <td style={tdL}>{r.satminkal}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {totalPages > 1 && (
              <div style={{ display:'flex',alignItems:'center',gap:8,marginTop:16,justifyContent:'center' }}>
                <Btn onClick={() => load(pg.page-1)} disabled={pg.page<=1} variant="secondary">← Prev</Btn>
                <span style={{ fontSize:12,color:'#6B7280' }}>Hal {pg.page} / {totalPages}</span>
                <Btn onClick={() => load(pg.page+1)} disabled={pg.page>=totalPages} variant="secondary">Next →</Btn>
              </div>
            )}
          </>
        )}
      </Card>
    </>
  );
};

// ── PENSIUN AKTUAL ───────────────────────────────────────
const PensiunAktualTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tahun, setTahun] = useState('');
  const [pg, setPg] = useState({ page:1, limit:20, total:0 });

  const load = async (page = 1) => {
    setLoading(true);
    const parts = [`page=${page}`, `limit=${pg.limit}`];
    if (tahun) parts.push(`tahun=${tahun}`);
    try {
      const r = await kekuatanAPI.getPensiunAktual(`?${parts.join('&')}`);
      setData(r.data || []);
      setPg(p => ({ ...p, page, total: r.pagination?.total || 0 }));
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const totalPages = Math.max(1, Math.ceil(pg.total / pg.limit));

  return (
    <>
      <Card>
        <div style={{ display:'flex',gap:12,alignItems:'flex-end',marginBottom:0 }}>
          <div style={{ display:'flex',flexDirection:'column',gap:4 }}>
            <label style={{ fontSize:12,fontWeight:600,color:'#374151' }}>Filter Tahun Pensiun</label>
            <input type="number" value={tahun} onChange={e => setTahun(e.target.value)} placeholder="Semua tahun"
              style={{ width:200,padding:'9px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box',fontFamily:'inherit' }}/>
          </div>
          <Btn onClick={() => load(1)}>Filter</Btn>
        </div>
      </Card>
      <Card>
        <h3 style={{ margin:'0 0 12px',fontSize:15,fontWeight:700 }}>Daftar Pensiun Aktual ({pg.total})</h3>
        {loading ? <p>Loading...</p> : (
          <>
            <table style={{ width:'100%',borderCollapse:'collapse' }}>
              <thead><tr style={{ background:'#F8FAFC' }}>
                {['No','NRP','Nama','Pangkat','Jenis Pensiun','TMT Pensiun','No. KEP'].map(h => <th key={h} style={th}>{h}</th>)}
              </tr></thead>
              <tbody>
                {data.length === 0
                  ? <tr><td colSpan={7} style={{ ...tdL,textAlign:'center',color:'#9CA3AF' }}>Tidak ada data pensiun aktual</td></tr>
                  : data.map((r,i) => (
                    <tr key={i} style={{ background:i%2===0?'transparent':'#FAFAFA' }}>
                      <td style={tdL}>{(pg.page-1)*pg.limit+i+1}</td>
                      <td style={tdL}>{r.nrp}</td>
                      <td style={tdL}>{r.nama}</td>
                      <td style={tdL}>{r.pangkat}</td>
                      <td style={tdL}>{r.jenis_pensiun}</td>
                      <td style={tdL}>{r.tmt_pensiun ? new Date(r.tmt_pensiun).toLocaleDateString('id-ID') : '-'}</td>
                      <td style={tdL}>{r.no_kep || '-'}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {totalPages > 1 && (
              <div style={{ display:'flex',alignItems:'center',gap:8,marginTop:16,justifyContent:'center' }}>
                <Btn onClick={() => load(pg.page-1)} disabled={pg.page<=1} variant="secondary">← Prev</Btn>
                <span style={{ fontSize:12,color:'#6B7280' }}>Hal {pg.page} / {totalPages}</span>
                <Btn onClick={() => load(pg.page+1)} disabled={pg.page>=totalPages} variant="secondary">Next →</Btn>
              </div>
            )}
          </>
        )}
      </Card>
    </>
  );
};

// ── MAIN ─────────────────────────────────────────────────
export default function KekuatanPage() {
  const [tab, setTab] = useState('diagram');
  const tabs = [
    { id:'diagram',   label:'Diagram Kekuatan Personil' },
    { id:'prediksi',  label:'Prediksi Kekuatan Personil' },
    { id:'nominatif', label:'Nominatif Kekuatan Personil' },
    { id:'pensiun-aktual', label:'Pensiun Aktual' },
  ];
  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:22,fontWeight:700,color:'#111827',margin:0 }}>Kekuatan Personil</h1>
        <p style={{ color:'#6B7280',fontSize:13,margin:'4px 0 0' }}>Diagram, Prediksi, dan Nominatif Kekuatan Personel TNI AD</p>
      </div>
      <div style={{ display:'flex',gap:0,marginBottom:20,borderBottom:'2px solid #E5E7EB' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding:'10px 20px',border:'none',background:'none',cursor:'pointer',
              fontSize:13,fontWeight:tab===t.id?700:500,
              color:tab===t.id?'#2563EB':'#6B7280',
              borderBottom:tab===t.id?'2px solid #2563EB':'2px solid transparent',
              marginBottom:-2,fontFamily:'inherit',whiteSpace:'nowrap' }}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'diagram'   && <DiagramTab/>}
      {tab === 'prediksi'  && <PrediksiTab/>}
      {tab === 'nominatif' && <NominatifTab/>}
      {tab === 'pensiun-aktual' && <PensiunAktualTab/>}
    </div>
  );
}
